import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * 判断点击组件时是否可以进行跳转，若可以，则返回一个回调函数，用于点击时执行 props.onJumpPage() 方法
 * 
 * @param {number} page - 需要跳转的页数
 * @param {boolean} prevent - 是否需要阻止跳转（如是否是当前页，是否是第一页或最后一页）
 * @param {function} [onJumpPage] - 若可以跳转的回调函数
 * @returns {function} 若能跳转，则返回一个新的回调函数用于执行跳转回调函数；否则返回 null
 */
const shouldJumpPage = (page, prevent, onJumpPage) => {
    if (onJumpPage && !prevent) {
        onJumpPage(page);
    }
    return null;
}

/**
 * 页码展示组件
 * 
 * @param {object} props - 传入参数
 * @param {number} props.page - 组件展示的页码
 * @param {boolean} [props.isSelected = false] - 是否为当前页
 * @param {function} [props.onJumpPage] - 若可以跳转的回调函数 
 * @returns {ReactElement} 页码组件
 */
const PagerIndex = ({ page, isSelected = false, onJumpPage }) => {
    let className = 'pager_index';
    if (isSelected) {
        className += ' selected';
    }

    const clk = (e) => {
        e.preventDefault();
        shouldJumpPage(page, isSelected, onJumpPage);
    }

    return (
        <a href="#" className={ className } onClick={ clk }>
            { page }
        </a>
    );
}

/**
 * 上一页下一页跳转按钮组件
 * 
 * @param {object} props - 传入参数
 * @param {number} props.page - 组件点击后跳转的页码
 * @param {string} props.action - 按钮类型，上一页 (prev) 或下一页 (next)
 * @param {boolean} [props.isDisabled = false] - 是否不可跳转
 * @param {function} [props.onJumpPage] - 若可以跳转的回调函数 
 * @returns {ReactElement} 按钮组件
 */
const PagerButton = ({ page, action, isDisabled = false, onJumpPage }) => {
    let className = 'pager_btn pager_' + action;
    if (isDisabled) {
        className += ' disabled';
    }

    const content = (action === 'next' ? '下一页' : '上一页');

    const clk = (e) => {
        e.preventDefault();
        shouldJumpPage(page, isDisabled, onJumpPage)
    }

    return (
        <a href="#" className={ className } onClick={ clk }>
            { content }
        </a>
    );
}

/**
 * 页码间省略号分隔符组件
 * 
 * @returns {ReactElement} 分隔符组件
 */
const PagerDot = () => {
    return (
        <span className="pager_dot">...</span>
    );
}

PagerIndex.propTypes = {
    page: PropTypes.number.isRequired,
    isSelected: PropTypes.bool,
    onJumpPage: PropTypes.func
}

PagerButton.propTypes = {
    page: PropTypes.number.isRequired,
    action: PropTypes.oneOf(['next', 'prev']).isRequired,
    isDisabled: PropTypes.bool,
    onJumpPage: PropTypes.func
}

export {
    PagerIndex,
    PagerButton,
    PagerDot
};


// WEBPACK FOOTER //
// ./client/component/pager/items.js